var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74408 16.4219C7.41864 16.0965 7.41864 15.5689 7.74408 15.2434L12.9882 9.99935L7.74408 4.75527C7.41864 4.42984 7.41864 3.9022 7.74408 3.57676C8.06951 3.25132 8.59715 3.25132 8.92259 3.57676L14.7559 9.41009C15.0814 9.73553 15.0814 10.2632 14.7559 10.5886L8.92259 16.4219C8.59715 16.7474 8.06951 16.7474 7.74408 16.4219Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderChevronRight);
export default __webpack_public_path__ + "static/media/header-chevron-right.d4a11da02ac35e99b4005fd406673de0.svg";
export { ForwardRef as ReactComponent };